/** Coalesce concurrent identical API reads within a short window. */

const inflight = new Map<string, Promise<unknown>>();

export function dedupeInflightRequest<T>(key: string, request: () => Promise<T>): Promise<T> {
  const existing = inflight.get(key);
  if (existing) return existing as Promise<T>;

  const promise = request().finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, promise);
  return promise;
}

/** @deprecated Use dedupeInflightRequest — kept for case detail call sites. */
export function dedupeCaseDetailRequest<T>(key: string, request: () => Promise<T>): Promise<T> {
  return dedupeInflightRequest(key, request);
}

/** Drop in-flight deduped reads (e.g. after creating a new review run). */
export function invalidateCaseDetailRequestPrefix(prefix: string): void {
  for (const key of inflight.keys()) {
    if (key.startsWith(prefix)) inflight.delete(key);
  }
}
